<template>
  <div>
    <UserGroups />
    <HrPermissionsSelector ref="permissionsSelector" />
  </div>
</template>

<script>
import UserGroups from "@/components/HrPermissions/UserGroups.vue";
import HrPermissionsSelector from "@/components/HrPermissions/HrPermissionsSelector.vue";

export default {
  name: "HrPermissions",
  components: {
    UserGroups,
    HrPermissionsSelector,
  },
  async mounted() {
    await this.$store.dispatch("permissions/fetchUserGroups");
    await this.$store.dispatch("permissions/fetchPermissionsSections");
    // تهيئة الصلاحيات المحددة بقائمة فارغة عند فتح الصفحة
    this.$store.dispatch("permissions/setSelectedPermissions", []);
  },
};
</script>

<style lang="scss" scoped></style>
